/*
 * Creation Time: March 1 - 2023
 * Created By: yasincelebi
 * Name: otp.tsx
 * Copyright 2023 customer-web-app
 */

import React, { useEffect } from 'react';
import { Button, OtpV2, Typography } from '@qlub-dev/qlub-kit';
import { useTranslation } from '../../../hook/translations';
import { useTimer } from '../../../hook/timer';
import { OtpSectionProps } from './index';

import styles from '../index.module.scss';

function OtpSectionV2({
    numInputs,
    code,
    onSetCode,
    showResendCode,
    resendSms,
    resendSmsCooldown,
    isReachedLimit,
    resendTimer,
    error,
}: OtpSectionProps) {
    const { text: timerText, setCurrentTime, second } = useTimer();
    const { t } = useTranslation('common');
    useEffect(() => {
        if (showResendCode && resendSmsCooldown) {
            setCurrentTime(resendSmsCooldown);
        }
    }, []);

    useEffect(() => {
        if (resendTimer && showResendCode && resendSmsCooldown) {
            setCurrentTime(resendSmsCooldown);
        }
    }, [resendTimer]);
    return (
        <>
            <OtpV2
                numInputs={Number(numInputs) || 5}
                shouldAutoFocus
                value={code}
                onChange={(val: string) => {
                    onSetCode(val);
                }}
                error={error}
                label="otp"
                isInputNum
                className={styles.otpinput}
                inputType="number"
            />
            <Typography sx={{ color: 'var(--destructive-text)', pt: 1, minHeight: '26px' }} typo="caption_overline">
                {error}
            </Typography>
            <div className={`${styles.linkWrapper} ${styles.secondVariation}`}>
                <div className={styles.resend2}>
                    {showResendCode &&
                        (isReachedLimit ? (
                            <span>{t('You have reached the limit of attempts. Please try again later.')}</span>
                        ) : (
                            <Button
                                sx={{
                                    padding: '4px 16px',
                                }}
                                variant="grey"
                                disabled={second > 0}
                                onClick={resendSms}
                            >
                                {second > 0
                                    ? `${t('I didn’t receive a code')} (${timerText})`
                                    : t('I didn’t receive a code')}
                            </Button>
                        ))}
                </div>
            </div>
        </>
    );
}

export default OtpSectionV2;
